import { useSupported } from '@vueuse/core';

export function useGeolocationPermission() {
  const isGeolocationSupported = useSupported(() => navigator && 'geolocation' in navigator);

  function requestGeolocationPermission() {
    return new Promise<void>((resolve) => {
      if (!isGeolocationSupported.value) {
        resolve();

        return;
      }

      navigator.geolocation.getCurrentPosition(() => resolve(), () => resolve());
    });
  }

  return {
    isSupported: isGeolocationSupported,
    requestGeolocationPermission,
  };
}
